import { EmailDeliveryTable } from '@Components/Billing';
import { type ApiInvoiceEmailDelivery } from '@Model';
import { Card, useTranslate } from '@synqo/frontend-component-library';
import { memo } from 'react';

// @ai-generated 2026-09-18T07:55:12+00:00 by philipp.kammerer@synqony.com using Claude Opus 5

interface IProps {
    emails: ApiInvoiceEmailDelivery[];
}

export const InvoiceEmailsSection = memo(function InvoiceEmailsSection({ emails }: IProps) {
    const i18n = useTranslate('');

    return (
        <Card name="emails" label={i18n('Versendete E-Mails')} closed={true}>
            <EmailDeliveryTable items={emails} />
        </Card>
    );
});
